import { Component, OnInit, ViewEncapsulation, Input, Output, ChangeDetectorRef, EventEmitter, OnChanges } from "@angular/core";
import { delay, SharedService } from '../../shared';
import { CannabisQuestion, CannabisAnswer, MedikamenteTable } from '../shared';


@Component({
    selector: 'medikamente-question',
    templateUrl: "./medikamente.component.html",
    styleUrls: ["./medikamente.component.scss"],
    encapsulation: ViewEncapsulation.None
})
export class MedikamenteQuestionComponent implements OnInit {
    @Input() partnerName: string = "";
    @Input() tableData: MedikamenteTable[] = [];
    @Output() onUpdateTable = new EventEmitter<any>();

    UnitList: string[] = ["g", "mg", "µg", "ml", "hub", "gtt"];
    DosierungList: string[] = ["0", "1/4", "1/2", "1", "2", "3"];
    ApplikationList: string[] = ["p.o.", "s.l.", "p.inhal.", "i.v.", "s.c.", "Pfl. oder transdermal"];

    constructor(private cd: ChangeDetectorRef,
        private sharedService: SharedService) {
    }

    ngOnInit(): void {
    }

    chooseApplikant(val: string, obj: MedikamenteTable) {
        obj.Applikation = val;
        this.valueChange(obj);
    }

    valueChange(obj: MedikamenteTable) {
        this.onUpdateTable.emit(this.tableData);
    }

    checkboxChange(obj: MedikamenteTable) {
        obj.Single = !obj.Single;
        this.valueChange(obj);
    }

}
